module.exports = __webpack_public_path__ + "img/56.0cf094e2.jpg";